import { version, Component } from 'react';
import { IS_KITCHEN_SINK } from '../utils/constants';
import { handleError } from '../utils/errorHandling';
import { jsx as _jsx } from "react/jsx-runtime";
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(__error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    const {
      identifier
    } = this.props;
    if (IS_KITCHEN_SINK) {
      console.error(`ErrorBoundary: ${identifier} is skipping error capture since we're in the kitchen sink app`, {
        error,
        errorInfo
      });
      return;
    }
    handleError(error, {
      extra: Object.assign({}, errorInfo, {
        version
      }),
      tags: {
        errorBoundaryName: identifier
      }
    });
  }
  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/_jsx("div", {
        "data-test-id": this.props.identifier,
        children: this.props.fallback
      });
    }
    return this.props.children;
  }
}